import React from 'react';
import { useNavigationSettings } from '../../hooks/useNavigationSettings';
import PageDisabled from '../../pages/Error/PageDisabled';

const PublicRouteGuard = ({ children, requiredPage }) => {
  const { data: navigationSettings, isLoading } = useNavigationSettings();

  // Si les paramètres de navigation sont en cours de chargement, afficher un loader
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  // Si la page est désactivée dans les paramètres de navigation
  if (requiredPage && navigationSettings && navigationSettings[requiredPage] === false) {
    const pageNames = {
      'projects': 'La page Projets',
      'users': 'La page Utilisateurs',
      'callForProjects': 'La page Appels à Projets',
      'subscriptions': 'La page Abonnements'
    };
    
    return <PageDisabled pageName={pageNames[requiredPage] || "Cette page"} />;
  }

  // Si tout est OK, afficher le composant
  return children;
};

export default PublicRouteGuard;
